@@ -0,0 +1,457 @@
<template>
    <div id="datatable">
        <v-data-table
            single-select
            :headers="headers"
            :items="items"
            :page.sync="currentPage"
            :items-per-page="visibleRow.value"
            hide-default-footer
            item-key="no"
            loading-text="Loading... Please wait"
            @dblclick:row="selectRowAndFinish"
        >
            <template v-slot:top>
                <v-card-text class="pa-0">
                    <v-container fluid>
                        <v-row no-gutters>
                            <v-col>
                                <!-- Search input by all headers key -->
                                <v-text-field
                                    id="datatable_search"
                                    v-model="query"
                                    outlined
                                    height="36px"
                                    hide-details
                                    small
                                    dense
                                    class="search_box"
                                    @keyup.enter="doBasicFilter()"
                                    placeholder="Ketik kata kunci dan tekan enter"
                                >
                                    <template slot="prepend-inner">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                                fill="#073554"
                                            />
                                            <path
                                                d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                                fill="#073554"
                                            />
                                        </svg>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <v-btn
                    v-if="item.status === 'TO_DO'"
                    small
                    depressed
                    rounded
                    color="#EB3123"
                    style="color: #ffffff"
                >
                    To Do
                </v-btn>

                <v-btn
                    v-if="item.status === 'DONE'"
                    small
                    depressed
                    rounded
                    color="#BCF8CC"
                    style="color: #00cf3f"
                >
                    Done
                </v-btn>

                <v-btn
                    v-if="item.status === 'IN_PROGRESS'"
                    small
                    depressed
                    rounded
                    color="#E1F4FC"
                    style="color: #0e97d6"
                >
                    In Progress
                </v-btn>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y v-if="hasAction">
                    <template v-slot:activator="{ on, attrs }">
                        <div icon v-bind="attrs" v-on="on">
                            <v-icon color="#4F4F4F" id="datatable_dot_btn"
                                >mdi-dots-vertical</v-icon
                            >
                        </div>
                    </template>

                    <v-list>
                        <v-list-item
                            class="test_cursor"
                            link
                            @click="updateItem(item)"
                        >
                            <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>

            <!-- Regenerate no by index, because no used for redirect to detail -->
            <template v-slot:[`item.no`]="{ index }">
                {{ items.length * (currentPage - 1) + (index + 1) }}
            </template>
        </v-data-table>

        <!-- Default pagination, shown total item '-' -->
        <div class="d-flex space-between pa-4">
            <span class="gray3--text">
                Menampilkan {{ items.length * currentPage }} dari -
            </span>
            <v-spacer />
            <v-btn
                depressed
                class="pa-0"
                :disabled="currentPage == 1"
                @click="goToPage(--currentPage)"
                min-width="32px"
                height="32px"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
                class="pa-0 mx-2"
                depressed
                dark
                color="blew"
                min-width="32px"
                height="32px"
            >
                {{ currentPage }}
            </v-btn>
            <v-btn
                depressed
                class="pa-0"
                min-width="32px"
                height="32px"
                :disabled="items.length < customPaginationPerPage"
                @click="goToPage(++currentPage)"
            >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "datatable",

    props: {
        items: { type: Array, default: [] },
        headers: { type: Array, default: [] },
        hasAction: { type: Boolean, default: true },
        hasExport: { type: Boolean, default: false },
        hasPreview: { type: Boolean, default: false },
        hasPublish: { type: Boolean, default: false },
        hasPaymentStatus: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        hasCustomPagination: { type: Boolean, default: false },
        hasCustomSearch: { type: Boolean, default: false },
        hasEdit: { type: Boolean, default: false },
        persistFilter: { type: Boolean, default: true },
        currentPageProp: { type: Number, default: 1 },
        customPaginationCurrentPage: { type: Number, default: 1 },
        customPaginationPerPage: { type: Number, default: 25 },
        customPaginationTotalItems: { type: Number, default: 0 },
        customPaginationTotalPages: { type: Number, default: 0 },
        customPaginationSortMode: { type: String, default: "desc" },
    },

    data: function () {
        return {
            currentPageItems: [],
            selectedRow: -1,
            filteredItems: [],
            query: null,
            orderBy: "desc",
            sorter: { text: "Baru ke Lama", value: true },
            field: 0,
            videoId: null,
            visibleRow: { text: "Row : 25", value: 25 },
        };
    },

    computed: {
        // not used
        player() {
            return this.$refs.youtube.player;
        },

        // set currentPage, if changed trigger goToPage to change data shown
        currentPage: {
            get: function () {
                if (this.hasCustomPagination) {
                    return this.customPaginationCurrentPage;
                }

                return parseInt(this.$store.state.datatable.currentPage);
            },

            set: function (val) {
                if (this.hasCustomPagination) {
                    this.goToPage(val);
                } else {
                    this.$store.commit("datatable_currentPage", val);
                }
            },
        },

        // not used
        pageStart: function () {
            return this.$store.state.datatable.pageStart;
        },

        // set pageSize, trigger data shown in one page
        pageSize: function () {
            return (
                this.customPaginationPerPage ||
                this.$store.state.datatable.pageSize
            );
        },

        // not used
        pageEnd: function () {
            return this.$store.state.datatable.pageEnd;
        },

        // set maxPage, if hasCustomPagination true set customPaginationTotalPages
        maxPage: function () {
            return this.hasCustomPagination
                ? this.customPaginationTotalPages
                    ? this.customPaginationTotalPages
                    : Math.ceil(this.customPaginationTotalItems / this.pageSize)
                : Math.ceil(this.filteredItems.length / this.pageSize);
        },

        // not used
        startNumber() {
            if (this.$route.name === "ItemBank") {
                return (this.currentPageProp - 1) * this.pageSize;
            } else {
                return (this.currentPage - 1) * this.pageSize;
            }
        },

        // not used
        filterCriteria: function () {
            var result = [];
            var filters = [];
            if (this.persistFilter)
                filters = this.$store.state.datatable.filters;

            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                var criteria = this.headers[filter.key] + " = " + filter.value;
                result.push(criteria);
            }

            return result;
        },
    },

    methods: {
        // Change sort by id
        updateOrderBy: function (e) {
            if (e.target) {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", e.target.value);
                else this.$store.commit("datatable_orderby", e.target.value);
            } else {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", e.target.value);
                else this.$store.commit("datatable_orderby", e);
            }
        },

        // Change data shown
        goToPage: function (page) {
            this.$emit("changePage", page);
        },

        // Not used
        publishing(item) {
            this.$emit("publishing", item);
        },

        // Not used
        unpublishing(item) {
            this.$emit("unpublishing", item);
        },

        // slice data to shown by max pageSize
        getItemsInPage: function (page) {
            page = this.hasCustomPagination ? 1 : page;
            var start = (page - 1) * this.pageSize;
            var end = start + this.pageSize;

            if (end > this.filteredItems.length - 1) {
                return this.filteredItems.slice(start);
            }

            return this.filteredItems.slice(start, end);
        },

        // notify deleted data by givev no data (but used)
        deleteItem: function (index) {
            var realIndex = index + (this.currentPage - 1) * this.pageSize;
            var selectedRow = this.hasCustomPagination
                ? this.selectRow(index)
                : this.filteredItems[realIndex];
            this.$emit("deleted", selectedRow);
        },

        // not used
        previewVideo: function (index) {
            if (index.url.indexOf("embed") > -1) {
                this.videoId = index.url.split("/")[4];
            } else {
                this.videoId = index.url.substring(index.url.indexOf("=") + 1);
            }
        },
        // give detail data choosen by index data
        selectRow: function (index) {
            var realIndex = this.hasCustomPagination
                ? index
                : index + (this.currentPage - 1) * this.pageSize;
            this.selectedRow = index;

            var selectedRow = this.filteredItems[realIndex];
            this.$emit("selected", selectedRow);

            return selectedRow;
        },

        // notify index data to dblClicked
        selectRowAndFinish(index, data = null) {
            var selectedRow = this.items.indexOf(data.item);
            console.log(selectedRow);
            this.$emit("dblClicked", selectedRow);
        },

        // notify exportClicked with detail data by index data (not used)
        exportItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("exportClicked", selectedRow);
        },

        updateItem(index, data = null) {
            var selectedRow = this.items.indexOf(data.item);
            console.log(selectedRow);
            this.$emit("updateItem", selectedRow);
        },

        // notify exportClicked with detail data by index data (not used)
        editItem(index) {
            var realIndex = index + (this.currentPage - 1) * this.pageSize;
            this.selectedRow = index;

            var selectedRow = this.filteredItems[realIndex];
            this.$emit("editNewTab", selectedRow);
        },

        // default filter by headerKeys
        doFilter: function () {
            if (this.field != null) {
                this.query = this.query !== null ? this.query.trim() : "";
                var criteria = { key: this.field, value: this.query };

                if (this.hasCustomSearch) {
                    // if hasCustomSearch true, store filter to datatable_push_filter and notify doSearch
                    this.goToPage(1);

                    this.$store.commit("datatable_push_filter", criteria);
                    this.$emit("doSearch", criteria);
                } else {
                    // if hasCustomSearch true, trigger doBasicFilter to search manualy with all data given
                    this.$store.commit("datatable_push_filters", criteria);
                    var filters = this.$store.state.datatable.filters;

                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i];
                        this.doBasicFilter(filter);
                    }

                    this.query = null;
                    this.field = 0;
                }
            }
        },

        // search manually with all data given (just work with data )
        doBasicFilter: function () {
            this.currentPage = 1;
            this.$emit("doSearch", this.query);
        },

        // remove all filters and goToPage 1
        clearFilter: function () {
            this.query = null;
            this.field = 0;
            this.filteredItems = this.items;
            this.$store.commit("datatable_pageStart", 1);
            this.$store.commit("datatable_pageEnd", 10);
            this.$store.commit("datatable_clear_filter");
            this.doOrder();

            if (this.hasCustomPagination)
                this.orderBy = this.customPaginationSortMode;
            else this.orderBy = this.$store.state.datatable.orderBy;
            if (!this.hasCustomSearch)
                this.$store.commit("datatable_clear_filters");
            if (this.hasCustomSearch) {
                this.goToPage(1);
                this.$emit("doSearch", { value: null, key: null });
            }
        },

        // order all data given by id data (not used)
        doOrder: function () {
            var tmp = this.filteredItems.slice(0);
            if (this.$store.state.datatable.orderBy == "asc") {
                tmp.sort(function (a, b) {
                    return a.id - b.id;
                });
            } else {
                tmp.sort(function (a, b) {
                    return b.id - a.id;
                });
            }

            this.filteredItems = tmp;
        },

        // not used
        playVideo() {
            this.player.playVideo();
        },

        // not used
        playing() {
            console.log("o/ we are watching!!!");
        },
    },

    watch: {
        // not used
        // if currentPage changed trigger getItemsInPage to make sure data shown not max with pageSize (not used)
        currentPage: function (page) {
            this.currentPageItems = this.getItemsInPage(page);
        },

        // not used
        loading: function () {
            if (!this.loading) {
                setTimeout(() => {
                    this.updateOrderBy(this.orderBy);
                    this.doOrder();
                }, 500);
            }
        },

        // put all data items to filteredItems
        items: function (val) {
            this.filteredItems = val;
            var fullPath = this.$route.fullPath;
            var datatableContext = this.$store.state.datatable.context;

            if (fullPath == datatableContext) {
                var filters = this.$store.state.datatable.filter;
                for (var i = 0; i < filters.length; i++) {
                    var filter = filters[i];
                    this.doBasicFilter(filter);
                }
            } else {
                this.$store.commit("datatable_context", fullPath);
                this.clearFilter();
            }
        },

        // not used
        filteredItems: function (val) {
            this.$store.commit("datatable_currentPage", 1);
            this.currentPageItems = this.getItemsInPage(this.currentPage);
        },

        // put value orderBy on this.sorter.value if orderBy changed
        orderBy: function (val) {
            if (val == "desc") {
                this.sorter.value = true;
            } else {
                this.sorter.value = false;
            }
            this.$store.commit("datatable_orderby", val);
            this.doOrder();
        },

        // trigger updateOrderBy if sorter changed
        sorter: function (val) {
            this.updateOrderBy();
        },
    },

    mounted: function () {
        this.filteredItems = this.items;
        this.currentPageItems = this.getItemsInPage(1);
        if (this.hasCustomPagination)
            this.orderBy = this.customPaginationSortMode;
        else this.orderBy = this.$store.state.datatable.orderBy;

        if (this.$store.state.datatable.filter != {}) {
            (this.query = this.$store.state.datatable.filter.value),
                (this.field = this.$store.state.datatable.filter.key);
        }
    },
};
</script>

<style scoped>
.search_box >>> .v-input__control {
    background: #fbfbfb !important;
    border: 1px solid rgba(230, 230, 230, 0.6) !important;
    border-radius: 8px !important;
}

.v-text-field--outlined >>> fieldset {
    border: 0 !important;
}

.search_box >>> .v-input__prepend-inner {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.v-data-table-header {
    color: #5c6275 !important;
    background: #f7f8fa !important;
}
</style>



// WEBPACK FOOTER //
// DataTable-s.vue?450a3db0